import { getUtcDate } from './date.helper';
import themeVariables from '@mais-retorno-front/theme/theme-variables';
import { FUND_WALLET_COLORS } from './fund-wallet-colors.constant';
import { renderTooltipFromProfitChartPRimeComponents } from '@mais-retorno-front/components/profit-chart/helper';
import { formatNumber } from '@core/design-system/utils';
import { DEFAULT_CHART_OPTIONS } from '@core/design-system/chart/chart-options';

export const CHART_OPTIONS = {
  quotaHoldersChartOptionsComparison: {
    yAxis: [
      {
        gridLineDashStyle: 'Dot',
        gridLineColor: '#BBB',
        title: {
          text: 'Cotistas',
        },
        opposite: false,
        startOnTick: true,
        min: null,
        tickPixelInterval: 35,
        minorTickLength: 0.0001,
        minorTicks: false,
        minPadding: 0.0001,
        maxPadding: 0.0001,
      },
    ],
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,
      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort((a, b) => b[1] - a[1]);

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px" class="text-center">' +
          getUtcDate(this.x) +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';

          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            (point[0].series.name !== 'Cotistas'
              ? formatNumber(point[0].y, { thousandMask: true })
              : formatNumber(parseInt(point[0].y), { thousandMask: true })) +
            '</td>';

          s +=
            '<td style="padding-bottom: 5px;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';

        return s;
      },
    },
  } as Highcharts.Options,
  quotaHoldersChartOptions: {
    chart: { height: 300 },
    yAxis: [
      {
        gridLineDashStyle: 'Dot',
        gridLineColor: '#BBB',
        title: { text: 'Cotistas' },
        startOnTick: true,
        opposite: true,
        min: null,
        tickPixelInterval: 50,
        minorTickLength: 0.0001,
        minorTicks: false,
        minPadding: 0.0001,
        maxPadding: 0.0001,
        labels: {
          formatter() {
            return formatNumber(this.value, {
              thousandMask: true,
              hideZero: true,
            });
          },
        },
      },
      {
        title: { text: 'Patrimônio médio por cotista' },
        gridLineDashStyle: 'Dot',
        gridLineColor: '#BBB',
        startOnTick: true,
        opposite: false,
        tickPixelInterval: 50,
        minorTickLength: 0.0001,
        minorTicks: false,
        minPadding: 0.0001,
        maxPadding: 0.0001,
        labels: {
          formatter() {
            return formatNumber(this.value, {
              type: 'money',
              thousandMask: true,
              hideZero: true,
            });
          },
        },
      },
    ],
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,
      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort((a, b) => b[1] - a[1]);

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px" class="text-center">' +
          getUtcDate(this.x) +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';

          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            (point[0].series.name !== 'Cotistas'
              ? formatNumber(point[0].y, { type: 'money', thousandMask: true })
              : formatNumber(parseInt(point[0].y), { thousandMask: true })) +
            '</td>';

          s +=
            '<td style="padding-bottom: 5px;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';

        return s;
      },
    },
  } as Highcharts.Options,
  dragDownChartOptions: {
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,
      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort((a, b) => {
          return a[1] - b[1];
        });

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px" class="text-center">' +
          getUtcDate(this.x) +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';
          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            formatNumber(point[0].y, { type: 'percent' }) +
            '</td>';
          s +=
            '<td style="padding-bottom: 5px; text-transform: uppercase;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';
        return s;
      },
    },
    yAxis: {
      type: 'linear',
      lineWidth: 0,
      lineColor: '#666666',
      labels: {
        formatter() {
          return `${formatNumber(this.value, { thousandMask: true })} %`;
        },
      },
      opposite: false,
      gridLineDashStyle: 'Dot',
      gridLineColor: '#BBB',
      plotLines: [
        {
          color: '#666666',
          width: 0,
          value: 0,
          zIndex: 2,
        },
      ],
      min: null,
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      title: { text: '' },
    },
  } as Highcharts.Options,
  volatilityChartOptions: {
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,
      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort((a, b) => {
          return a[1] - b[1];
        });

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px" class="text-center">' +
          getUtcDate(this.x) +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';
          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            formatNumber(point[0].y, { type: 'percent' }) +
            '</td>';
          s +=
            '<td style="padding-bottom: 5px; text-transform: uppercase;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';
        return s;
      },
    },
    yAxis: {
      type: 'linear',
      lineWidth: 1,
      lineColor: '#666666',
      labels: {
        formatter() {
          return `${formatNumber(this.value, { thousandMask: true })} %`;
        },
      },
      opposite: false,
      gridLineDashStyle: 'Dot',
      gridLineColor: '#BBB',
      plotLines: [
        {
          color: '#666666',
          width: 1,
          value: 0,
          zIndex: 2,
        },
      ],
      startOnTick: false,
      endOnTick: false,
      max: null,
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      title: { text: '' },
    },
  } as Highcharts.Options,
  netWorthChartOptions: {
    yAxis: {
      lineWidth: 1,
      lineColor: '#666666',
      labels: {
        formatter() {
          return formatNumber(this.value, {
            type: 'money',
            thousandMask: true,
            hideZero: true,
          });
        },
      },
      opposite: false,
      gridLineDashStyle: 'Dot',
      gridLineColor: '#BBB',
      plotLines: [
        {
          color: '#666666',
          width: 1,
          value: 0,
          zIndex: 2,
        },
      ],
      startOnTick: true,
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      title: { text: '' },
    },
    navigator: { enabled: false },
    scrollbar: { enabled: false },
    rangeSelector: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,

      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort(function (a, b) {
          return b[1] - a[1];
        });

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px;" class="text-center">' +
          getUtcDate(this.x) +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';
          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            formatNumber(point[0].y, { type: 'money', thousandMask: true }) +
            '</td>';
          s +=
            '<td style="padding-bottom: 5px;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';
        return s;
      },
    },
  } as Highcharts.Options,
  fundWalletHistoryChartOptions: {
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
    },
    colors: FUND_WALLET_COLORS,
    chart: {
      height: '500px',
      type: 'area',
    },
    plotOptions: {
      area: {
        stacking: 'percent',
        opacity: 0.4,
        marker: { enabled: false },
      },
    },
    yAxis: {
      type: 'linear',
      lineWidth: 0,
      lineColor: '#666666',
      labels: {
        format: '{value}%',
      },
      gridLineWidth: 0,
      plotLines: [
        {
          color: '#666666',
          width: 0,
          value: 0,
          zIndex: 2,
        },
      ],
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      title: { text: '' },
    },
    tooltip: {
      shared: true,
      split: false,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#BBB',
      borderRadius: 3,
      shadow: false,
      useHTML: true,
      formatter() {
        const ticks = [];

        for (const funds in this.points) {
          ticks.push([this.points[funds], this.points[funds].y]);
        }

        ticks.sort((a, b) => b[1] - a[1]);

        let s = '<table style="width:100%;">';
        s +=
          '<tr><td colspan="2" style="font-weight: bold; padding-top: 6px" class="text-center">' +
          getUtcDate(this.x, 'MMMM - YYYY') +
          '<hr ></td><tr>';

        ticks.forEach(function (point) {
          s +=
            '<tr style="font-weight: bold; color:' +
            point[0].series.color +
            '">';

          s +=
            '<td style="padding-bottom: 5px; padding-right: 4px;">▌ ' +
            `${formatNumber(point[0].percentage, {
              type: 'percent',
            })} (${formatNumber(point[0].y, {
              type: 'money',
              thousandMask: true,
            })}) </td>`;

          s +=
            '<td style="padding-bottom: 5px;"> |  ' +
            point[0].series.name.slice(0, 20);
          if (point[0].series.name.length > 20) {
            s += '...';
          }
          s += '</td>';
          s += '</tr>';
        });

        s += '</table>';

        return s;
      },
    },
  } as Highcharts.Options,
  percentChart: {
    title: { text: null },
    navigator: { enabled: false },
    scrollbar: { enabled: false },
    rangeSelector: { enabled: false },
    credits: { enabled: false },
    exporting: { enabled: false },
    chart: {
      zooming: {
        type: 'x',
        mouseWheel: {
          enabled: false,
        },
      },
      type: 'line',
      panning: { enabled: false },
      spacing: [10, 10, 0, 0],
      backgroundColor: 'transparent',
    },
    legend: {
      enabled: true,
      align: 'left',
      verticalAlign: 'top',
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        color: themeVariables.colors.secondary,
      },
    },
    xAxis: {
      type: 'datetime',
      lineWidth: 1,
      lineColor: '#BBB',
      dateTimeLabelFormats: {
        week: { main: '%Y' },
        month: { main: '%Y' },
        year: { main: '%Y' },
      },
    },
    yAxis: {
      title: { text: null },
      opposite: false,
      lineWidth: 0,
      lineColor: '#666',
      gridLineDashStyle: 'Dot',
      gridLineColor: '#BBB',
      plotLines: [
        {
          color: '#CCC',
          width: 1,
          value: 0,
          zIndex: 2,
        },
      ],
      startOnTick: true,
      endOnTick: true,
      max: null,
      softMin: 0, // This will ensure the y-axis starts at 0 but allows negative values to be displayed
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      labels: {
        formatter() {
          return formatNumber((this.value as number) * 100, {
            type: 'percent',
          });
        },
      },
    },
    series: [],
    tooltip: {
      shared: true,
      split: false,
      shadow: false,
      useHTML: true,
      borderRadius: 4,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#CCC',
      formatter() {
        return renderTooltipFromProfitChartPRimeComponents.call(
          this,
          'percent',
          100
        );
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxHeight: 270,
          },
        },
      ],
    },
  } as Highcharts.Options,
  successRateChatOptions: {
    chart: {
      height: 260,
      type: 'column',
    },
    legend: {
      enabled: true,
      align: 'left',
      verticalAlign: 'top',
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        color: themeVariables.colors.secondary,
        compare: undefined,
        opacity: 0.8,
      },
      column: {
        pointPadding: 0.2,
        maxPointWidth: 80,
        borderWidth: 0,
      },
    },
    xAxis: {
      categories: [
        '3 meses',
        '6 meses',
        '12 meses',
        '24 meses',
        '36 meses',
        '48 meses',
        '60 meses',
      ],
      lineWidth: 1,
      lineColor: '#BBB',
      crosshair: true,
    },
    yAxis: {
      ...DEFAULT_CHART_OPTIONS.yAxis,
      title: { text: null },
      opposite: false,
      lineWidth: 0,
      lineColor: '#666',
      gridLineDashStyle: 'Dot',
      gridLineColor: '#BBB',
      plotLines: [
        {
          color: '#CCC',
          width: 1,
          value: 0,
          zIndex: 2,
        },
      ],
      startOnTick: true,
      endOnTick: true,
      min: 0,
      max: 100,
      tickPixelInterval: 35,
      minorTickLength: 0.0001,
      minorTicks: false,
      minPadding: 0.0001,
      maxPadding: 0.0001,
      labels: {
        formatter() {
          return this.value + '%';
        },
      },
    },
    tooltip: {
      shared: true,
      split: false,
      shadow: false,
      useHTML: true,
      borderRadius: 4,
      backgroundColor: 'rgba(255,255,255,0.85)',
      borderColor: '#CCC',
      className: null,
      formatter() {
        return renderTooltipFromProfitChartPRimeComponents.call(
          this,
          'percent',
          1,
          true
        );
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxHeight: 270,
          },
        },
      ],
    },
  } as Highcharts.Options,
  // columnRanges: {
  //   chart: { type: 'columnrange', backgroundColor: null },
  //   title: { text: null },
  //   navigator: { enabled: false },
  //   scrollbar: { enabled: false },
  //   rangeSelector: { enabled: false },
  //   credits: { enabled: false },
  //   exporting: { enabled: false },
  //   legend: {
  //     enabled: true,
  //     align: 'left',
  //     verticalAlign: 'top',
  //   },
  //   plotOptions: {
  //     series: {
  //       color: themeVariables.colors.secondary,
  //     },
  //     columnrange: {
  //       dataLabels: {
  //         enabled: true,
  //         formatter: function () {
  //           if (this.point.low === this.y) {
  //             return formatNumber(this.point.low, { type: 'percent' });
  //           } else if (this.point.high === this.y) {
  //             return formatNumber(this.point.high, { type: 'percent' });
  //           } else {
  //             return null;
  //           }
  //         },
  //         inside: false,
  //         verticalAlign: 'top',
  //       },
  //     },
  //   },
  //   yAxis: {
  //     title: { text: null },
  //     opposite: false,
  //     lineWidth: 0,
  //     tickPixelInterval: 35,
  //     lineColor: '#666',
  //     gridLineDashStyle: 'Dot',
  //     gridLineColor: '#BBB',
  //     plotLines: [
  //       {
  //         color: '#CCC',
  //         width: 1,
  //         value: 0,
  //         zIndex: 2,
  //       },
  //     ],
  //     startOnTick: true,
  //     endOnTick: true,
  //     max: null,
  //     labels: {
  //       formatter() {
  //         return formatNumber(this.value, { type: 'percent' });
  //       },
  //     },
  //   },
  //   xAxis: {
  //     lineWidth: 1,
  //     lineColor: '#BBB',
  //   },
  //   tooltip: {
  //     headerFormat: '<em>Experiment No {point.key}</em><br/>',
  //   },
  // } as Highcharts.Options,
};
